
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_r2vco_16xuq_9",
  "dropdown-header": "awsui_dropdown-header_r2vco_16xuq_41",
  "dropdown-footer": "awsui_dropdown-footer_r2vco_16xuq_47"
};
  